import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [// 首页
        {
            path: '/', name: 'Home', component: () => import('@/views/index.vue'), meta: {
                keepAlive: false
            }
        }, // 关于我们
        {
            path: '/about', name: 'About', component: () => import('@/views/About.vue'), meta: {
                keepAlive: false
            }
        }, // 企业新闻
        {
            path: '/news', name: 'News', component: () => import('@/views/News.vue'), meta: {
                keepAlive: false
            }
        }, // 项目合作
        {
            path: '/cooperation', name: 'Cooperation', component: () => import('@/views/Cooperation.vue'), meta: {
                keepAlive: false
            }

        },  // 新闻详情

        {
            path: '/news/detail/:id', name: 'NewsDetail', component: () => import('@/views/NewsDetail.vue'), meta: {
                requiresAuth: true, headerActive: 'News', keepAlive: false
            }
        },

        // 数藏计划
        {
            path: '/digitalCollection',
            name: 'DigitalCollection',
            component: () => import('@/views/DigitalCollection.vue'),
            meta: {
                keepAlive: false
            }
        }],

    // 切换页面滚动到页面顶部
    scrollBehavior() {
        return {x: 0, y: 0}
    },
})
